import React, { useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import useFetch from 'use-http';

const GroupedSearchResults = ({ results, lastQuery }) => {
  const healthCheckExternalId = process.env.REACT_APP_HEALTH_CHECK_EXTID;
  const labResearchProgramsExtId =
    process.env.REACT_APP_LAB_RESEARCH_PROGRAMS_EXTID;
  const { request: logUserSearchResultsSelectionRequest } = useFetch(
    '/UserSearchManagement/searchResultSelectionLog',
  );

  const { request: complexServiceRequest } = useFetch(
    '/Services/CombinedServices',
  );

  const history = useHistory();
  const [expandedGroups, setExpandedGroups] = useState({});

  const isUltrasoundServiceType = (service) =>
    service.serviceTypeExternalId ==
    process.env.REACT_APP_ULTRASOUND_SERVICE_TYPE_EXT_ID;

  const expandGroup = (group) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [group]: true,
    }));
  };

  const handleItemClick = async (service) => {
    let redirectUrl = '';
    if (service.type === 'ServiceComplex') {
      redirectToServicePage(service);
      return;
    }

    // if (!service.hasUpcomingVisits) {
    //   return;
    // }

    if (service.serviceTypeExternalId == labResearchProgramsExtId) {
      redirectUrl = `/kompleksines-paslaugos?serviceId=${service.serviceId}&departmentId=${service.departmentId}`;
    } else {
      redirectUrl = `/services/${service.categoryId}/${service.serviceTypeId}`;

      if (
        service.serviceTypeExternalId !==
        process.env.REACT_APP_SGKN_SERVICE_TYPE_EXT_ID
      ) {
        if (service.serviceId) {
          redirectUrl += `?serviceId=${service.serviceId}`;
        }
        if (service.specialistId) {
          redirectUrl += `&specialistId=${service.specialistId}`;
        }

        if (service.departmentId) {
          redirectUrl += `&departmentId=${service.departmentId}`;
        }

        if (service.cityId) {
          redirectUrl += `&cityId=${service.cityId}`;
        }

        if (service.specialtyId) {
          redirectUrl += `&specialtyId=${service.specialtyId}`;
        }

        // redirectUrl = `/order/${service.workplaceId}/${service.serviceId}`;
      } else {
        redirectUrl = service.specialistId
          ? `/services/${service.categoryId}/${service.serviceTypeId}?specialistId=${service.specialistId}`
          : `/services/${service.categoryId}/${service.serviceTypeId}`;
      }
    }

    if (redirectUrl) {
      try {
        await logUserSearchResultsSelection(
          service.serviceId,
          service.workplaceId,
          lastQuery,
          redirectUrl,
        );
      } catch (err) {
        console.warn('Logging failed:', err);
      }

      history.push(redirectUrl);
    }
  };

  const logUserSearchResultsSelection = async (
    serviceId,
    workplaceId,
    query,
    url,
  ) => {
    try {
      await logUserSearchResultsSelectionRequest.post('', {
        serviceId,
        workplaceId,
        searchPhrase: query,
        SelectedResultUrl: url,
      });
    } catch (err) {
      // Log silently
    }
  };

  const redirectToServicePage = (service) => {
    let redirectUrl = '';
    if (service.isHolter) {
      redirectUrl = `/kompleksines-paslaugos?serviceId=${service.serviceId}&holter=${service.isHolter}`;
    } else if (service.serviceTypeExternalId == healthCheckExternalId) {
      redirectUrl = `/services/${service.categoryId}/${service.serviceTypeId}`;
      if (service.serviceId) {
        redirectUrl += `?serviceId=${service.serviceId}`;
      }
    } else {
      redirectUrl = `/kompleksines-paslaugos?serviceId=${service.serviceId}`;
    }
    const url = `?serviceId=${service.serviceId}&holter=${service.isHolter}`;

    complexServiceRequest.get(url).then((r) => {
      if (r?.length !== 1) {
        return;
      }

      logUserSearchResultsSelection(
        service.serviceId,
        service.workplaceId,
        lastQuery,
        redirectUrl,
      ).finally(() => {
        history.push(redirectUrl);
      });
    });
  };

  const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const highlightMatches = (text) => {
    const safeText = text ?? '';

    if (!lastQuery?.trim()) return safeText;

    const keywords = lastQuery
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .filter((word) => word.length > 0)
      .map(escapeRegex); // <-- escape each word

    if (keywords.length === 0) return text;

    const splitRegex = new RegExp(`(${keywords.join('|')})`, 'gi');
    const matchRegex = new RegExp(`^(${keywords.join('|')})$`, 'i');

    const chunks = safeText.split(splitRegex);

    return (
      <span>
        {chunks.map((chunk, index) =>
          matchRegex.test(chunk) ? (
            <mark className="bg-yellow-200" key={`${chunk}-${index}`}>
              {chunk}
            </mark>
          ) : (
            <React.Fragment key={`${chunk}-${index}`}>{chunk}</React.Fragment>
          ),
        )}
      </span>
    );
  };

  return (
    <div className="absolute top-full left-0 w-full bg-white border border-t-0 rounded-b-[1.6rem] border-gray-500 z-50 overflow-hidden">
      <Scrollbars autoHeight autoHeightMax={600}>
        {Object.keys(results).length > 0 ? (
          <div>
            {Object.keys(results).map((groupKey) => {
              const group = results[groupKey];
              const isExpanded = expandedGroups[groupKey];
              const visibleItems = isExpanded ? group : group.slice(0, 5);
              const canExpand = group.length > 5 && !isExpanded;

              return (
                <div
                  key={groupKey}
                  className="px-5 py-3 border-t first:border-t-0"
                >
                  {/* Group Title */}
                  <div className="text-sm font-semibold text-[#5180CA] uppercase mb-2">
                    {groupKey}
                  </div>

                  {/* Results */}
                  {visibleItems.map((service, idx) => (
                    <div
                      key={idx}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        handleItemClick(service);
                      }}
                      className="mb-3 last:mb-0 px-3 py-2 rounded-lg hover:bg-gray-100 cursor-pointer transition"
                    >
                      <div className="font-normal leading-snug">
                        {service.specialistName ? (
                          <>
                            <div className="text-xl text-black">
                              {highlightMatches(
                                `${service.specialistName} - ${service.serviceTitle}`,
                              )}
                            </div>
                            <div className="text-base text-[#677489] pt-1">
                              {service.specialty && (
                                <span>
                                  {highlightMatches(service.specialty)} -{' '}
                                </span>
                              )}
                              <span>
                                {highlightMatches(service.departmentName)}
                              </span>
                              {service.departmentAddress && (
                                <span>
                                  {''},{' '}
                                  {highlightMatches(service.departmentAddress)}
                                </span>
                              )}
                              {!service.hasUpcomingVisits && (
                                <span>
                                  {isUltrasoundServiceType(service) &&
                                  service.workplaceTypeId === 'Tyrimas'
                                    ? ' - Pagal poreikį atliekamas konsultacijos metu'
                                    : ' - Nėra laisvų vizitų'}
                                </span>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="font-normal  leading-snug">
                              <div className="text-xl text-black">
                                {highlightMatches(service.serviceTitle)}
                              </div>
                              {service.type !== 'ServiceComplex' && (
                                <div className="text-base text-[#677489] pt-1">
                                  <span>
                                    {highlightMatches(service.departmentName)}
                                  </span>
                                  {service.departmentAddress && (
                                    <span>
                                      {''},{' '}
                                      {highlightMatches(
                                        service.departmentAddress,
                                      )}
                                    </span>
                                  )}
                                  {!service.hasUpcomingVisits && (
                                    <span> - Nėra laisvų vizitų</span>
                                  )}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* Show More Button */}
                  {canExpand && (
                    <div className="mt-2 flex justify-center bg-[#FBFDFF] p-2 rounded-md">
                      <button
                        onMouseDown={(e) => {
                          e.preventDefault();
                          expandGroup(groupKey);
                        }}
                        className="flex items-center justify-center w-full cursor-pointer select-none focus:outline-none"
                      >
                        <svg
                          className="w-3 h-3"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>

                        <span className="text-xs text-blue-[#1F4B81] font-semibold">
                          Rodyti daugiau
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="p-5 text-center text-sm text-[#677489]">
            Nerasta rezultatų
          </div>
        )}
      </Scrollbars>
    </div>
  );
};

export default GroupedSearchResults;
